/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

const Container = styled.div`
  background-color ${t.color.white};
  box-shadow: 0px 3px 5px 0 rgba(0, 0, 0, 0.3);

  ${t.mixins.sm(`
    background-color: transparent;
    box-shadow: none;
  `)}
`;
const Title = styled.h3`
  margin: 0 auto 34px auto;
  max-width: 493px;
  ${t.mixins.rem(26, 32)}
  font-family: ${t.font.primary};
  color: ${t.color.primary};
  text-align: center;

  ${t.mixins.sm(`
    margin: 0 auto 36px auto;
    max-width: 355px;
  `)}
`;

/**
 * container component is..
 */

const Shadow__container = ({ style, children, title, className }) => (
  <Container style={style} className={className}>
    {title && <Title>{title}</Title>}
    {children}
  </Container>
);

export default Shadow__container;

Shadow__container.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Shadow__container.defaultProps = {
  style: {},
};

/*
    import Shadow__container from 'components/shadow/container/shadow__container'
    <Shadow__container />
  */
